import { FavoriteButtonWidgetElement } from './define-favorite-button-element';

export function registerFavoriteButtonWidget() {
  if (typeof window === 'undefined') return;
  if (window.customElements.get('adipa-favorite-button')) return;

  window.customElements.define('adipa-favorite-button', FavoriteButtonWidgetElement);
}
